import z from "zod";
import { worksites } from "../../../attendances";
import { geoCoordinatesSchema } from "../../geo-coordinates";
import { attendanceWorksiteRefine } from "../attendance-form.schema";

/**
 * The body of a check-in and of a check-out: the worksite is absent on a check-out, where the
 * server ends the live attendance and asks for nothing else.
 *
 * A project travels with `project-site` only — the rule `attendanceWorksiteRefine` holds for the
 * native form and the requirements query as well. A commute headed for a project is not a check-in
 * shape: it arises from a worksite change, whose body names the project as `commuteProjectId`
 * (`postAttendanceMigrateWorksiteBodySchema`) and whose handler builds the commute attendance
 * without passing this schema; that is the path on which `startAttendance` resolves a
 * `commuteTarget` of `project-site`.
 */
export const postAttendanceBodySchema = z
	.object({
		worksite: z.enum(worksites).optional(),
		projectId: z.uuid().optional(),
		acknowledgedDefinitionIds: z.array(z.uuid()).optional(),
		acknowledgedRiskAssessments: z.boolean().optional(),
	})
	.extend(geoCoordinatesSchema)
	.superRefine(attendanceWorksiteRefine);

export type PostAttendanceBodySchema = z.infer<typeof postAttendanceBodySchema>;
